import { render, staticRenderFns } from "./ContractDetailsTransactions.vue?vue&type=template&id=660ad4c0&scoped=true"
import script from "./ContractDetailsTransactions.vue?vue&type=script&lang=js"
export * from "./ContractDetailsTransactions.vue?vue&type=script&lang=js"
import style0 from "./ContractDetailsTransactions.vue?vue&type=style&index=0&id=660ad4c0&prod&lang=scss&scoped=true"
import style1 from "./ContractDetailsTransactions.vue?vue&type=style&index=1&id=660ad4c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660ad4c0",
  null
  
)

export default component.exports